import { useState } from "react";

import { useStartQaRun } from "../../../qa-automation-api";
import { PlatformModal } from "../../../platform-modal";
import styles from "./start-run-modal.module.css";

export function QaStartRunModal({ onClose, onStarted }: { onClose: () => void; onStarted: (runId: string) => void }) {
  const [grep, setGrep] = useState("");
  const start = useStartQaRun();
  const submit = () => start.mutate(
    { projects: ["desktop"], ...(grep.trim() ? { grep: grep.trim() } : {}) },
    { onSuccess: ({ runId }) => { onClose(); onStarted(runId); } },
  );
  return <PlatformModal
    title="Start new QA run"
    error={start.error?.message || (start.error ? "Failed to start run." : null)}
    confirmLabel="Start run"
    pendingLabel="Starting…"
    pending={start.isPending}
    onClose={onClose}
    onConfirm={submit}
  >
    <label className={styles.field}><span>Project</span><select className={styles.input} value="desktop" disabled><option value="desktop">desktop</option></select></label>
    <label className={styles.field}><span>Grep filter <em>(optional)</em></span><input className={styles.input} type="text" value={grep} disabled={start.isPending} placeholder="e.g. login to run matching tests" onChange={(event) => setGrep(event.target.value)} /></label>
  </PlatformModal>;
}
